import { memo, useEffect, useRef, useState } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

function formatAmount(n) {
  if (!n && n !== 0) return '';
  const num = Number(n);
  if (num >= 100000) return `${num / 100000}L`;
  if (num >= 1000) return `${num / 1000}K`;
  return String(num);
}

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}

function bookCls(v) {
  if (!v) return 'book-black';
  return v < 0 ? 'book-red' : 'book-green';
}

// Bootstrap collapse animation (.collapsing CSS app.css me)
function CollapseBody({ id, open, children }) {
  const ref = useRef(null);
  const first = useRef(true);
  const [cls, setCls] = useState('collapse show');
  const [style, setStyle] = useState(undefined);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    const el = ref.current;
    if (!el) return;
    let raf1;
    let raf2;
    if (open) {
      setCls('collapsing');
      setStyle({ height: '0px' });
      raf1 = requestAnimationFrame(() => {
        raf2 = requestAnimationFrame(() => setStyle({ height: `${el.scrollHeight}px` }));
      });
    } else {
      setStyle({ height: `${el.scrollHeight}px` });
      raf1 = requestAnimationFrame(() => {
        setCls('collapsing');
        raf2 = requestAnimationFrame(() => setStyle({ height: '0px' }));
      });
    }
    const t = setTimeout(() => {
      setCls(open ? 'collapse show' : 'collapse');
      setStyle(undefined);
    }, 350);
    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
      clearTimeout(t);
    };
  }, [open]);

  return (
    <div id={id} ref={ref} className={`bet-table-body ${cls} container-fluid container-fluid-5`} style={style}>
      {children}
    </div>
  );
}

// Lucky 15 (lucky15) — reference: single "Runs" market-6, header pe collapse
// toggle (#market-runs). 6 selections (0/1/2/4/6 Runs + Wicket), back-only,
// col-6 col-md-6 grid (2-col), book hamesha visible (book-black at 0),
// fancy-min-max newline-separated.
const BetTableLucky15 = memo(function BetTableLucky15({ gameData, onBet, exposures }) {
  const sub = gameData?.sub ?? [];
  const [open, setOpen] = useState(true);

  return (
    <div className="market-6">
      <div className="bet-table">
        <div
          data-toggle="collapse"
          data-target="#market-runs"
          aria-expanded={open ? 'true' : 'false'}
          className={`bet-table-header${open ? '' : ' collapsed'}`}
          onClick={() => setOpen((v) => !v)}
        >
          <div className="nation-name">
            <span title="Runs">
              {'\n          Runs\n        '}
            </span>
          </div>
        </div>
        {' '}
        <CollapseBody id="market-runs" open={open}>
          <div className="row row5 d-none-mobile">
            {[0, 1].map((i) => (
              <div key={i} className="col-6 col-md-6">
                <div className="fancy-tripple">
                  <div className="bet-table-row">
                    <div className="nation-name"></div>
                    {' '}
                    <div className="back bl-title back-title">Back</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {' '}
          <div className="row row5">
            {sub.map((item, i) => {
              const suspended = isSusp(item);
              const b = item?.b ?? item?.b1 ?? '';
              const bs = item?.bs ?? item?.bs1 ?? '';
              const book = roundBook(exposures?.[`sid:${item?.sid}`] ?? exposures?.[item?.nat] ?? 0);
              return (
                <div key={item?.sid ?? i} className="col-6 col-md-6">
                  <div className="fancy-tripple">
                    <div className="bet-table-mobile-row d-none-desktop">
                      <div className="bet-table-mobile-team-name">
                        <span>{item?.nat ?? ''}</span>
                        {' '}
                        <span className={bookCls(book)}>{fmtBook(book)}</span>
                      </div>
                    </div>
                    {' '}
                    <div className="bet-table-row">
                      <div className="nation-name d-none-mobile">
                        <p>
                          {'\n                    ' + (item?.nat ?? '') + '\n                  '}
                        </p>
                        {' '}
                        <p className={`mb-0 ${bookCls(book)}`}>{fmtBook(book)}</p>
                      </div>
                      {' '}
                      <div
                        data-title={suspended ? 'SUSPENDED' : 'OPEN'}
                        className={`bl-box back${suspended ? ' no-val suspended' : ''}`}
                        onClick={suspended ? undefined : () => onBet && onBet(item.sid, 'back', b, item)}
                      >
                        <span className="d-block odds">{suspended ? '—' : b}</span>
                        {' '}
                        {!suspended && <span className="d-block">{formatAmount(bs)}</span>}
                      </div>
                      {' '}
                      <div className="fancy-min-max">
                        {'\n                  Min:'}
                        <span>{formatAmount(item?.min ?? '')}</span>
                        {'\n                  Max:'}
                        <span>{formatAmount(item?.max ?? '')}</span>
                      </div>
                    </div>
                    {' '}
                  </div>
                </div>
              );
            })}
          </div>
        </CollapseBody>
      </div>
    </div>
  );
});

export default BetTableLucky15;
